
import { PropertiesByShape } from './types'

export function getPropertiesBySingleShape(shape: string, flip: boolean): PropertiesByShape {
  let properties: PropertiesByShape
  switch (shape) {
    case 'diagonal':
      properties = {
        logoAlignment: '50%',
        primaryPath: 'M0 0 h33 L100 100 h-33 z',
        secondaryPath: 'M6 0 h5 L79 100 h-5 z'
      }
      break
    default:
      properties = {
        logoAlignment: flip ? '58%' : '42%',
        primaryPath: 'M0 0 H100 L0 100 V0',
        secondaryPath: 'M0 85 v5 L90 0 h-5 z'
      }
  }
  return properties
}

export function getPropertiesByDualShape(shape: string, flip: boolean): PropertiesByShape {
  let properties: PropertiesByShape
  switch (shape) {
    case 'diagonal':
      properties = {
        leftLogo: {
          top: flip ? '68%' : '32%',
          left: '27.5%'
        },
        rightLogo: {
          top: flip ? '32%' : '68%',
          left: '72.5%'
        },
        primaryPath: 'M0 0 h23.56 L71.43 100 h-23.56 z',
        secondaryPath: 'M4.28 0 h3.57 L56.43 100 h-3.57 z'
      }
      break
    default:
      properties = {
        logoAlignment: flip ? '58%' : '42%',
        primaryPath: 'M0 0 H100 L0 100 V0',
        secondaryPath: 'M0 85 v5 L90 0 h-5 z'
      }
  }
  return properties
}

export function shouldRenderSvg(shape: string) {
  switch (shape) {
    case 'diagonal':
      return true
    default:
      return false
  }
}